<fury-page>
    <fury-title class="title">
        <h2> Update Lead Partner Content</h2>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="leadPartnerContentForm">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
            style="margin-bottom: 20px;align-items: baseline; width: 100% !important;">
            <div class="flex">
              <div class="innerdiv">
                <div class="uploadsec" style="margin-right: 20px">
                  <div class="imgsec">
                    <img [src]="bannerImage ?  bannerImage : '../../../../../assets/img/no_thumbnail.jpg'" alt="badge_image"> <span (click)="removeBadge()" *ngIf="bannerImage" class="removebadge"><mat-icon>close</mat-icon></span>
                  </div>
                  <div class="uploadbtnsec">
                    <input type="file" #image_one (change)="onImageUpload($event)" accept=".png, .jpg, .jpeg"
                      style="display:none">
                    <button class="uploadfilebtn" mat-raised-button (click)="image_one.click()">Upload image</button>
                  </div>
                </div>
              </div>
            </div>
            </fxLayout>
            <mat-form-field appearance="outline">
              <mat-label>Partner Heading</mat-label>
              <textarea matInput placeholder="Partner Heading" formControlName="partnerHeading"></textarea>
            </mat-form-field>
            
            <mat-form-field appearance="outline">
              <mat-label>Partner Offer</mat-label>
              <textarea matInput placeholder="Partner Offer" formControlName="partnerOffer"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Partner Description</mat-label>
              <textarea matInput placeholder="Partner Description" formControlName="partnerDescription"></textarea>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Recommended Text</mat-label>
              <textarea matInput placeholder="Recommended Text" formControlName="recommendedText"></textarea>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Recommended Company</mat-label>
              <input matInput placeholder="Recommended Company" formControlName="recommendedCompany">
            </mat-form-field>
          </div>
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button"
            (click)="editContent()"><span>Update Content</span></button>
            <button mat-button type="button" class="can-button" (click)="back()"><span>Cancel</span></button>
          </div>
            
          </form>
    </div>
  </div>
